/*
 * @Author: 张霞 1738830106@qq.com
 * @Date: 2023-08-25 09:34:48
 * @LastEditors: 张霞 1738830106@qq.com
 * @LastEditTime: 2024-09-07 10:31:57
 * @FilePath: /ChileCashy-web/src/lang/en-US/index.js
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
export default {
	priority: {
		home: 'Home',
		product: 'Product',
		about: 'About Us',
		language: 'Language',
		reliablePartner: 'Your reliable partner',
		homeText1: 'All-in-one solution for your any personal or business transaction requirements',
		details: 'Details',
		personal: 'For Personal',
		business: 'For Business',

		homeText2: 'Looking forward to having you join us!',
		introduction: 'Introduction',
		contact: 'Contact Us',
		address: 'Address',
		started: 'Get Started',

		oproducts: 'Our Products',
		remittanceNeeds: 'for any remittance needs',
		productText1:
			'Make transfer transactions anywhere and anytime in minutes with flat fees. We provide world-class financial services that are intuitive, fast, easy to use, and affordable for everyone and businesses, regardless of type and size.',
		exchangeRate: 'Exchange Rate',
		amount: 'Amount',
		exchange: 'Exchange',
		rate: 'Rate',
		domesticTransfer: 'Domestic Transfer',
		sendMoney: 'Send money without worry',
		productText2: 'You can transfer to anyone in Chile anywhere and anytime without worry. The transaction can be finished in minutes.',
		remittance: 'Remittance Cross-Border',
		remittanceFP: 'Remittance to your family and partners',
		productText3: 'You can transfer to your family, friends and your business partners abroad safe and fast in full amount.',
		remittanceAaccounts: 'Remittance to one or many accounts',
		productText4: 'Funds disbursement to accommodate all your  business needs, both manual and automatic, to one or many accounts at once.',

		aboutText1: 'To build the future of Open Finance with cutting-edge technology and a mission to improve financial inclusion',
		aboutText2:
			'INVERSIONES MAS CREDITO（IMC） is an online remittance service that helps you send money abroad from Chile in an easier, cheaper, and faster way. IMC aims to always provide the best service for our users to send money abroad from Chile. We designed our products and services based on Chile market to provide a seamless transaction experience for your customers.',
		waw: 'Who Are We？',
		licensedby: 'Licensed by',
		License: 'License No. 12/42/DASP/10',
		destination: 'Choose Destination',
		transactionEasier: 'Transaction Easier',
		aboutText3: 'Finish your remittance on your cellphone without extra offline steps. ',
		fasterSafer: 'Faster and Safer',
		aboutText4: 'Recipient can receive the money in minutes. Money will be  refunded if transaction fails risk.',
		competitivePricing: 'Competitive Pricing',
		aboutText5: 'Lower price and flat transfer fee, to save your money as much as possible with tailored financial solution.',
		customerService: '7*24 Hours Customer Service',
		aboutText6: 'We will support you anytime when you need us.',
		aboutText7: 'Advantage',
		footerTip: 'InversionesX（INVERSIONES MAS CREDITO SpA）- All rights reserved',

	},
}
